import { render, staticRenderFns } from "./MatchPage.vue?vue&type=template&id=7f85f4d4&"
import script from "./MatchPage.vue?vue&type=script&lang=js&"
export * from "./MatchPage.vue?vue&type=script&lang=js&"
import style0 from "./MatchPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MatchPage.vue"
export default component.exports